import { preloader } from './modules/preloader/';

